import { render, staticRenderFns } from "./Estorno.vue?vue&type=template&id=70dd4fb6&"
import script from "./Estorno.vue?vue&type=script&lang=js&"
export * from "./Estorno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports